import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { getOrder } from '@/services/client';
import { formatRub, statusLabel } from '@/utils/format';

export default function OrderStatus() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['client/order', id],
    queryFn: () => getOrder(id!),
    enabled: !!id,
    refetchInterval: 10_000,
  });

  if (isLoading) return <div className="p-6 text-center">Загрузка…</div>;
  if (!data) return <div className="p-6 text-center">Заказ не найден</div>;

  return (
    <div className="pt-4">
      <div className="px-4 mb-4">
        <h1 className="text-2xl font-semibold">Заказ №{data.number}</h1>
        <div className="text-sm text-brand-600 mt-1">{statusLabel[data.status] ?? data.status}</div>
      </div>

      <div className="px-4 card p-4 space-y-2">
        {data.items.map((i) => (
          <div key={i.id} className="flex justify-between text-sm">
            <span>{i.name} × {i.quantity}</span>
            <span>{formatRub(i.total)}</span>
          </div>
        ))}
        <div className="pt-2 border-t border-slate-100 flex justify-between font-semibold">
          <span>Итого</span>
          <span>{formatRub(data.total)}</span>
        </div>
      </div>

      <div className="px-4 mt-6">
        <Link to="/menu" className="btn-outline w-full">Ещё заказ</Link>
      </div>
    </div>
  );
}
